module.exports = __webpack_public_path__ + "img/case08.07ef2a86.png";